import React from "react";
import styles from "./MakerNoteSection.module.css";
import { Container } from "../../common/Container";
import { makerNote } from "../../../data/compassData";

/** A first-person note from the developer, placed just before pricing. */
export const MakerNoteSection: React.FC = () => (
  <section className={styles.section} aria-labelledby="maker-note-title">
    <Container>
      <figure className={styles.note}>
        <h2 id="maker-note-title" className={styles.srOnly}>
          Why Compass exists
        </h2>
        <blockquote className={styles.quote}>
          <p>{makerNote.quote}</p>
        </blockquote>
        <figcaption className={styles.byline}>
          <img
            src="/images/compass/logo.png"
            alt=""
            aria-hidden="true"
            width={40}
            height={40}
            className={styles.mark}
          />
          <span>
            <span className={styles.name}>{makerNote.name}</span>
            <span className={styles.role}>{makerNote.role}</span>
          </span>
        </figcaption>
      </figure>
    </Container>
  </section>
);
